// GRYP · micro-interactions communes (chargé en différé par snippets/gryp-head.liquid).

// Cartes pièce (snippets/gryp-product-card.liquid) : en mobile, le premier tap montre le dos, le second ouvre la fiche.
// Au survol (desktop), le CSS s'en charge.
document.addEventListener('click', (event) => {
  const media = event.target.closest('.gryp-ess__media--flip');
  if (!media || matchMedia('(hover: hover)').matches || media.classList.contains('is-flipped')) return;
  event.preventDefault();
  document.querySelectorAll('.gryp-ess__media.is-flipped').forEach((m) => m.classList.remove('is-flipped'));
  media.classList.add('is-flipped');
});

// Tiroir du panier : un lien du tiroir (« Tous les essentiels » du panier vide, une pièce) ferme le tiroir avant la page suivante.
// Sans cela, la page d'arrivée s'affichait avec le tiroir toujours ouvert (transitions de page d'Horizon).
document.addEventListener('click', (event) => {
  const link = event.target.closest('#cart-drawer a[href]');
  if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || link.target === '_blank') return;
  document.getElementById('cart-drawer')?.close?.();
});

// Confirmation d'ajout au panier : petite touche perso (snippets/gryp-touch.liquid, transmise par une meta de gryp-head),
// affichée quand Horizon confirme l'ajout (événement standard shopify:cart:lines-update, action « add »). Annoncée aux lecteurs d'écran.
document.addEventListener('shopify:cart:lines-update', (event) => {
  const action = event.action ?? event.detail?.action;
  const text = document.querySelector('meta[name="gryp:confirmation-ajout"]')?.content;
  if (action !== 'add' || !text) return;
  Promise.resolve(event.promise).then(() => {
    let toast = document.querySelector('.gryp-toast');
    if (!toast) {
      toast = document.createElement('p');
      toast.className = 'gryp-toast';
      toast.setAttribute('role', 'status');
      document.body.append(toast);
    }
    toast.textContent = text;
    toast.classList.add('is-on');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => toast.classList.remove('is-on'), 1800);
  }).catch(() => {});
});

// Galerie de la fiche produit (desktop) : la dernière image d'un nombre impair prend toute la largeur (gryp.css). Horizon lui annonce
// la largeur d'une demi-colonne (sizes) : on annonce sa vraie largeur, sinon le navigateur charge une image trop petite, floue.
const grypLargeGalleryImage = () => {
  if (!matchMedia('(min-width: 750px)').matches) return;
  document.querySelectorAll('.media-gallery--two-column .media-gallery__grid > .product-media-container:last-child:nth-child(odd)').forEach((item) => {
    const width = Math.ceil(item.getBoundingClientRect().width);
    const img = item.querySelector('img');
    if (img && width) img.sizes = `(min-width: 750px) ${width}px, 100vw`;
  });
};
grypLargeGalleryImage();
addEventListener('resize', () => { clearTimeout(grypLargeGalleryImage.timer); grypLargeGalleryImage.timer = setTimeout(grypLargeGalleryImage, 200); });

// Manifeste de la Home (sections/gryp-manifeste.liquid) : boucle de photos d'ambiance en fondu enchaîné lent.
// Les photos 2 à 6 ne sont chargées que quand la section approche de l'écran ; la boucle tourne seulement quand la section
// est visible, et passe à la photo suivante une fois celle-ci chargée. prefers-reduced-motion : 1re photo seule, rien d'autre.
document.querySelectorAll('[data-gryp-loop]').forEach((section) => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const images = [...section.querySelectorAll('.gryp-manifeste__media img')];
  if (images.length < 2) return;
  const delay = Number(section.dataset.duree) || 6000;
  let index = 0;
  let timer;
  const load = (img) => {
    if (!img.dataset.src) return;
    img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    delete img.dataset.src;
  };
  const next = () => {
    const target = images[(index + 1) % images.length];
    if (!target.complete || !target.naturalWidth) return; // pas encore chargée : on réessaie au tour suivant
    images[index].classList.remove('is-active');
    target.classList.add('is-active');
    index = images.indexOf(target);
  };
  new IntersectionObserver(([entry]) => {
    clearInterval(timer);
    if (!entry.isIntersecting) return;
    images.forEach(load);
    timer = setInterval(next, delay);
  }, { rootMargin: '200px 0px' }).observe(section);
});

// Chargement des images (gryp.css, « Chargement ») : fond gris clair tant que l'image n'est pas là, puis fondu doux à l'apparition.
// Le fondu ne s'applique qu'aux images encore en chargement et sans animation propre : on ne touche ni aux révélations au scroll,
// ni aux heros (vidéo et affiche), ni à la boucle du manifeste, ni aux photos au survol, ni aux cartes face / dos.
(() => {
  const ANIMATED = [
    '[data-gryp-reveal] img', '.gryp-manifeste__media img', '.gryp-hero img', '.gryp-drop__hero img', '.gryp-drop__hero-media img',
    '.gryp-ess__media img', '.gryp-drop__piece-media img', '.gryp-drop-list__media img', '.gryp-events-page__media img',
    '.gryp-hover-photo img', '.gryp-ig-card__img img', '.gryp-ev-page__cover img', '.gryp-ev__next-media img',
  ].join(',');
  const hasOwnMotion = (img) => {
    if (img.matches(ANIMATED)) return true;
    const style = getComputedStyle(img);
    return style.animationName !== 'none' || /opacity|all/.test(style.transitionProperty) && parseFloat(style.transitionDuration) > 0;
  };
  document.querySelectorAll('main img').forEach((img) => {
    const done = () => img.classList.add('is-loaded');
    if (img.complete && img.naturalWidth) return done();
    if (!hasOwnMotion(img)) img.classList.add('gryp-fade');
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  });
})();

// Photo au survol des listes (archives et events, Home et pages Events et Archives, desktop) : UNE seule photo partagée par liste
// ([data-gryp-hover-list]), qui change d'image d'une ligne à l'autre. Chaque ligne ([data-gryp-hover-item]) garde sa photo dans un
// <template data-gryp-hover-img> (rien n'est chargé sur mobile) ; les photos sont copiées dans la photo partagée quand la liste
// approche de l'écran. Passer vite d'une ligne à l'autre change l'image sans rien empiler ; la photo ne s'efface qu'en quittant
// la liste, et sa transition repart de là où elle en est si on y revient. Rien ne reste affiché au retour arrière (bfcache).
// Placement (15/10/2026, référence : la page Archives) : cadre standard 4:5 (gryp.css) qui suit le curseur avec un léger amorti
// sur les deux axes, sur toutes les lignes (même en haut ou en bas de l'écran), à droite du texte survolé ([data-gryp-hover-text]) ; toujours entièrement dans l'écran
// (ramené juste assez, sous le header) et jamais sur le texte survolé (à gauche de la ligne s'il n'y a pas la place à droite).
(() => {
  const desktop = matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const MARGIN = 16;
  document.querySelectorAll('[data-gryp-hover-list]').forEach((list) => {
    let photo = null;
    let current = null;
    let row = null;
    let x = 0, y = 0, cx = 0, cy = 0, raf = 0;

    const build = () => {
      if (photo) return;
      photo = document.createElement('div');
      photo.className = 'gryp-hover-photo';
      photo.setAttribute('aria-hidden', 'true');
      list.querySelectorAll('[data-gryp-hover-item]').forEach((item) => {
        const img = item.querySelector('template[data-gryp-hover-img]')?.content.querySelector('img')?.cloneNode(true);
        if (!img) return;
        img.loading = 'eager';
        img.alt = '';
        item.grypHoverImg = img;
        photo.append(img);
      });
      document.body.append(photo);
    };

    // Position visée : centrée sur le curseur, ramenée dans l'écran (sous le header, au-dessus du bas).
    const target = () => {
      const w = photo.offsetWidth, h = photo.offsetHeight;
      const header = document.querySelector('#header-component');
      const minTop = (header ? Math.max(0, header.getBoundingClientRect().bottom) : 0) + MARGIN;
      const r = row.getBoundingClientRect();
      // Fin réelle du texte survolé (pas la largeur de sa colonne).
      const range = document.createRange();
      range.selectNodeContents(row.querySelector('[data-gryp-hover-text]') || row);
      const text = range.getBoundingClientRect();
      const maxTop = Math.max(minTop, innerHeight - h - MARGIN);
      // À droite du curseur, jamais sur le texte survolé (il reste lisible) ; s'il n'y a pas la place à droite,
      // en miroir à gauche du curseur (toujours hors du texte), sinon à gauche de la ligne ; jamais hors de l'écran.
      let left = Math.max(x + 24, text.right + 32);
      if (left + w > innerWidth - MARGIN) {
        const mirror = Math.min(x - 24, text.left - 32) - w;
        if (mirror >= MARGIN) left = mirror;
        else if (r.left - 32 - w >= MARGIN) left = r.left - 32 - w;
      }
      return {
        left: Math.min(left, innerWidth - w - MARGIN),
        // Le point de la photo accroché au curseur glisse de son haut (curseur en haut de l'écran) à son bas (curseur en bas) :
        // elle monte et descend avec le curseur sur toutes les lignes, sans jamais buter contre un bord de l'écran.
        top: Math.min(Math.max(y - h * Math.min(Math.max((y - minTop) / (innerHeight - MARGIN - minTop), 0), 1), minTop), maxTop),
      };
    };
    const place = () => {
      raf = 0;
      if (!row) return;
      const t = target();
      const k = reduce.matches ? 1 : 0.18;
      cx += (t.left - cx) * k;
      cy += (t.top - cy) * k;
      photo.style.transform = `translate3d(${cx}px, ${cy}px, 0)`;
      if (Math.abs(t.left - cx) + Math.abs(t.top - cy) > 0.5) raf = requestAnimationFrame(place);
    };
    const update = () => { if (!raf) raf = requestAnimationFrame(place); };

    const hide = () => { photo?.classList.remove('is-on'); row = null; };
    const show = (item, px, py) => {
      build();
      const img = item.grypHoverImg;
      if (!img) return hide(); // ligne sans photo
      // Photo déjà effacée (ou presque) : elle réapparaît directement à sa place, sans glisser depuis l'ancienne.
      const hidden = parseFloat(getComputedStyle(photo).opacity) < 0.05;
      if (current !== img) {
        current?.classList.remove('is-current');
        img.classList.add('is-current');
        current = img;
      }
      row = item;
      x = px; y = py;
      if (hidden) { const t = target(); cx = t.left; cy = t.top; }
      update();
      photo.classList.add('is-on');
    };

    list.addEventListener('pointerover', (e) => {
      if (e.pointerType !== 'mouse' || !desktop.matches) return;
      const item = e.target.closest('[data-gryp-hover-item]');
      if (item && list.contains(item)) show(item, e.clientX, e.clientY);
    });
    list.addEventListener('pointermove', (e) => {
      if (row) { x = e.clientX; y = e.clientY; update(); }
    });
    list.addEventListener('pointerleave', hide);
    // Défilement à la molette sans bouger la souris : la photo se recale (écran, header, texte survolé).
    document.addEventListener('scroll', () => { if (row) update(); }, { passive: true, capture: true });
    // Clavier : la photo de la ligne qui a le focus, à droite de son texte.
    list.addEventListener('focusin', (e) => {
      const item = e.target.closest('[data-gryp-hover-item]');
      if (!desktop.matches || !item?.matches(':focus-visible')) return;
      const r = (item.querySelector('[data-gryp-hover-text]') || item).getBoundingClientRect();
      show(item, r.right, r.top + r.height / 2);
    });
    list.addEventListener('focusout', (e) => { if (!list.contains(e.relatedTarget)) hide(); });
    addEventListener('pagehide', hide);
    desktop.addEventListener('change', hide);

    // Les photos se chargent quand la liste approche de l'écran (desktop seulement) : la première est prête au premier survol.
    const io = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting || !desktop.matches) return;
      build();
      io.disconnect();
    }, { rootMargin: '300px 0px' });
    io.observe(list);
  });
})();
